// removed by extract-text-webpack-plugin
module.exports = {"publication":"magazines_3QW3A","page":"magazines_irvl1","preview":"magazines_3BGpC","magazine-container":"magazines_3JIuQ","pages-container":"magazines_MO8aJ","pages":"magazines_UzG4K","nav":"magazines_1QuO9","nav-left":"magazines_1OsqR","nav-right":"magazines_30052","gradients-even":"magazines_BaeM-","gradients-odd":"magazines_1vzo4"};


//////////////////
// WEBPACK FOOTER
// ./src/components/publish/PublishComponent.scss
// module id = 268
// module chunks = 1